<template>
	<div id="login-register-template">
		<appCreateProgressBar />
		<div class="login-register-content">
			<div class="inner">
				<div v-if="!showRegisterPanel">
					<LoginPanel />
					<!-- <div class="register-box col xs-12 md-6">
						<div class="register-box__title">New User</div>
						<div class="register-box__subhead">Manage your quotes and surveys online</div>
						<ul>
							<li class="icon__target">Fast Fixed Quotes</li><br />
							<li class="icon__security">Highly Secure SSL Access</li><br />
							<li class="icon__cloud">Access your Surveys anywhere</li>
						</ul>
						<button class="btn" @click="showRegisterPanel = true">New User</button>	
						
				
					</div> -->
					<div class="clearfix"></div>
				</div>
				<div v-else>
					<div class="registration-panel">
						<div class="panel-header" :class="{panelHeaderNameAddress : nameAddresPanel, panelHeaderContactDetails : contactDetailsPanel}">
							<div class="registration-panel__title">Please enter your details</div>
						</div>
						<div class="name-address-panel" :class="{active : nameAddresPanel, inactive : contactDetailsPanel}">
							<p class="field-group-heading underline">Name and Address</p>

							<div class="content" @keyup.enter="goNextSlide">
								<div class="registration-input col md-6">
									<input type="text" placeholder="First Name" v-model="formData.firstName">
								</div>
								<div class="registration-input col md-6">
									<input type="text" placeholder="Last Name" v-model="formData.lastName">
								</div>
								<div class="registration-input col md-6">
									<input type="text" placeholder="Company Name" v-model="formData.companyName">
								</div>
								<div class="registration-input col md-6">
									<input type="text" placeholder="Address Line 1" v-model="formData.addressLineOne">
								</div>
								<div class="registration-input col md-6">
									<input type="text" placeholder="Address Line 2 ( optional )" v-model="formData.addressLineTwo">
								</div>
								<div class="registration-input col md-6">
									<input type="text" placeholder="Town/City" v-model="formData.city">
								</div>
								<div class="registration-input col md-6">
									<input type="text" placeholder="Postcode" v-model="formData.postCode">
								</div>
								<button class="btn" @click="goNextSlide">Next</button>
							</div>
						</div>
						<div class="contact-details-panel" :class="{ active : contactDetailsPanel, inactive : nameAddresPanel}"  @keyup.enter="createAccount">
							<p class="field-group-heading underline">Contact Details</p>

							<div class="content">
								<div class="registration-input-desc col md-12">
									<p>We'll only contact you to discuss your survey quote.</p>
								</div>
								<div class="registration-input col md-6">
									<input type="email" placeholder="Email address" v-model="formData.email">
								</div>
								<div class="registration-input col md-6">
									<input type="tel" placeholder="Phone Number" v-model="formData.phoneNumber">
								</div>
								<div class="registration-input col md-6">
									<div class="col md-6 registration-input__pwd"><input type="password" placeholder="Password" v-model="formData.password"></div>
									<div class="col md-6 registration-input__confirm-pwd"><input type="password" placeholder="Confirm Password" v-model="confirmPassword"></div>
								</div>
								<div class="registration-input col md-6">
									<input type="text" placeholder="Phone Number 2 ( optional )" v-model="formData.phoneNumberTwo">
								</div>
								<div class="col md-12 submit-container">
									<div class="col md-8">
										<p>By clicking confirm, you agree to our <a href="http://www.topographical.co.uk/terms-use" target="_blank">Terms of Use</a> and <a href="http://www.topographical.co.uk/privacy-policy" target="_blank">Privacy Policy.</a></p>
									</div>
									<div class="col md-4 registration-input__controls">
										<button class="registration-input__back outline" @click="goBackSlide">Back</button>
										<button class="btn" @click="createAccount" >Confirm</button>	
									</div>
									
								</div>
							</div>
							
						</div>

						<div class="clearfix"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import CreateProgressBar from '../common/Create/CreateProgressBar';
import LoginPanel from '../common/Login/LoginPanel';


export default {
	data(){
		return {
			showRegisterPanel : false,
			nameAddresPanel : true,
			contactDetailsPanel : false,
			confirmPassword : "",
			formData : {
				email : "",
				password : "",
				firstName : "",
				lastName : "",
				companyName : "",
				addressLineOne : "",
				addressLineTwo : "",
				city : "",
				postCode : "",
				phoneNumber : "",
				phoneNumberTwo : ""
			}
		}
	},
	components : {
		appCreateProgressBar : CreateProgressBar,
		LoginPanel : LoginPanel
	},
	computed : {

	},
	methods : {
		goNextSlide(){

			// validate first
			let formData = this.formData;
			let message = "";

			if(!formData.lastName){message = "You must provide your Last Name.";}
			if(!formData.firstName){message = "You must provide your Full Name";}
			if(!formData.companyName){message = "You must provide your Company Name";}
			if(!formData.addressLineOne){message = "You must provide the first line of your Address";}
			if(!formData.city){message = "You must provide your Town/City";}
			if(!formData.postCode){message = "You must provide your Postcode";}

			if(message.length){
				this.$toasted.error(message, {
                        theme: 'bubble',
                        position: 'bottom-center',
                        duration: 4000
                })
                return;
			} else {
				this.nameAddresPanel = false;
				this.contactDetailsPanel = true; 
			}
			
		},
		goBackSlide(){
			this.nameAddresPanel = true;
			this.contactDetailsPanel = false; 
		},

		
		createAccount(){
			let formData = this.formData;
			let message = "";

			if(!formData.email){ message = "You must provide an Email Address";}
			if(!formData.phoneNumber){message = "You must provide a Phone Number";}
			if(!formData.email){message = "You must provide an Email Address";}
			//if(!formData.password){message = "You must provide an Password";}
			//if(!this.confirmPassword){message = "You must confirm your Password";}
			//if(this.confirmPassword !== formData.password){message = "Your Passwords must match";}
			//if(formData.password.length <= 9){message = "Your Password should be 10 characters or longer";}
			if(message.length){
				this.$toasted.error(message, {
                        theme: 'bubble',
                        position: 'bottom-center',
                        duration: 4000
                })
                return;
			} else {
				this.$toasted.show("Please wait...", {
                        theme: 'bubble',
                        position: 'bottom-center',
                        duration: null
                })
    			this.$store.dispatch('userRegister', formData)
    			.then((response) => {
					this.$store.commit('openModal', 'ConfirmQuoteModal');
    				this.$toasted.clear();
    				if(response.confirmation === 'success'){
    					this.$toasted.success("success", {
		                    theme: 'bubble',
		                    position: 'bottom-center',
		                    duration: 5000
		                })	
    					return;
    				}
    				if(response.confirmation === 'validation'){
    					this.$toasted.error(response.message, {
		                    theme: 'bubble',
		                    position: 'bottom-center',
		                    duration: 5000
		                })
    				} else {
    					this.$toasted.error(response.message, {
		                    theme: 'bubble',
		                    position: 'bottom-center',
		                    duration: 5000
		                })
    				}
    			})
    			.catch((err) => {
    				this.$toasted.clear();
    				this.$toasted.error("something went wrong. " + err.message, {
		                theme: 'bubble',
		                position: 'bottom-center',
		                duration: 5000
		            })
    			})
			}

		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Login.vue